<template>
    <table-cell :href="href" class="w-px">
        <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
    </table-cell>
</template>

<script>
import Icon from "@/Shared/Icon"
import TableCell from "./TableCell";

export default {
    components: {
        TableCell,
        Icon,
    },
    props: {
        href: String,
    }
}
</script>